module.exports = __webpack_public_path__ + "static/media/cara-feliz.3ff0daaf.png";